import { readPref, writePref } from './prefs'

/**
 * Foydalanuvchi tema tanlovi.
 *   - `auto`  — hech narsa majburlanmaydi: brauzerda `prefers-color-scheme`, Telegram ichida
 *               `lib/telegram.ts` bergan qiymat hal qiladi (standart, avvalgi xatti-harakat).
 *   - `light` / `dark` — `<html data-theme>` orqali MAJBURLANADI, tizim tanlovidan ustun.
 */
export type ThemePref = 'light' | 'dark' | 'auto'

/**
 * `localStorage` kaliti.
 *
 * ⚠️ `index.html` dagi FOUC oldini oluvchi inline skript ham AYNAN shu kalitni o'qiydi
 * (birinchi bo'yoqdan oldin temani qo'llash uchun). Kalit o'zgarsa — u yerda ham yangilang.
 */
export const THEME_STORAGE_KEY = 'ayub:theme'

export function getThemePref(): ThemePref {
  const raw = readPref(THEME_STORAGE_KEY)
  return raw === 'light' || raw === 'dark' || raw === 'auto' ? raw : 'auto'
}

/**
 * Foydalanuvchi temani QO'LDA (light/dark) tanlaganini bildiradi. `lib/telegram.ts` shu
 * holatda avtomatik derivatsiyani o'tkazib yuboradi — tanlov ustun bo'lishi uchun.
 */
export function hasExplicitThemePref(): boolean {
  const pref = getThemePref()
  return pref === 'light' || pref === 'dark'
}

/** `<html data-theme>` ni preferensga qarab qo'yadi yoki (auto) olib tashlaydi. */
export function applyThemePref(pref: ThemePref): void {
  const root = document.documentElement
  if (pref === 'auto') {
    delete root.dataset.theme
  } else {
    root.dataset.theme = pref
  }
}

export function setThemePref(pref: ThemePref): void {
  writePref(THEME_STORAGE_KEY, pref)
  applyThemePref(pref)
}
